import axiosInstance from './axios';

export const shipmentService = {
  list: async (params = {}) => {
    const response = await axiosInstance.get('/shipments', { params });
    return response.data;
  },

  show: async (id) => {
    const response = await axiosInstance.get(`/shipments/${id}`);
    return response.data;
  },

  create: async (orderId, overrides = {}) => {
    const response = await axiosInstance.post('/shipments', {
      order_id: orderId,
      overrides,
    });
    return response.data;
  },

  preview: async (orderId) => {
    const response = await axiosInstance.get('/shipments/preview', {
      params: { order_id: orderId },
    });
    return response.data;
  },

  refresh: async (id) => {
    const response = await axiosInstance.post(`/shipments/${id}/refresh`);
    return response.data;
  },

  label: async (id) => {
    const response = await axiosInstance.post(`/shipments/${id}/label`);
    return response.data;
  },

  cancel: async (id) => {
    const response = await axiosInstance.delete(`/shipments/${id}`);
    return response.data;
  },

  ping: async () => {
    const response = await axiosInstance.get('/shipments/ping');
    return response.data;
  },

  districts: async (params = {}) => {
    const response = await axiosInstance.get('/shipments/districts', { params });
    return response.data;
  },

  pickups: async () => {
    const response = await axiosInstance.get('/shipments/pickups');
    return response.data;
  },
};

export const SHIPMENT_STATUS_LABEL = {
  pending:          { label: 'En attente',         color: '#6c757d', bg: '#e9ecef' },
  created:          { label: 'Créée chez Sendit',  color: '#0d6efd', bg: '#cfe2ff' },
  picked_up:        { label: 'Ramassée',           color: '#0d6efd', bg: '#cfe2ff' },
  in_transit:       { label: 'En transit',         color: '#664d03', bg: '#fff3cd' },
  out_for_delivery: { label: 'En livraison',       color: '#664d03', bg: '#fff3cd' },
  delivered:        { label: 'Livrée',             color: '#0f5132', bg: '#d1e7dd' },
  returned:         { label: 'Retournée',          color: '#842029', bg: '#f8d7da' },
  cancelled:        { label: 'Annulée',            color: '#842029', bg: '#f8d7da' },
  failed:           { label: 'Échec',              color: '#842029', bg: '#f8d7da' },
};
